import React, { useState, useEffect } from "react";
import logo from "../../images/logo.png";
import HeaderDash from "../HeaderDash/";
import AutoComplete from "../Autocomplete/";
import handleAutoComplete from "../Autocomplete";
import Pictures from "../Pictures/index";
import Item from "./Item";

import css from "./Dash.module.css";
import { SERVER_URL } from "../../config";

function Dash() {
  const [contractDisp, setContractDisp] = useState([]);
  useEffect(() => {
    fetch(`${SERVER_URL}/contracts`)
      .then(res => res.json())
      .then(data => setContractDisp(data.payload));
  }, []);

  return (
    <div className={css.gridContainer}>
      <HeaderDash />

      <div className={css.pendingContracts}>
        {contractDisp.map(item => (
          <Item {...item} />
        ))}
      </div>

      <div className={css.Picturesdiv}>
        <Pictures />
      </div>
    </div>
  );
}

export default Dash;
